<template>
    <v-row justify="center">
        <v-dialog
            class="user-modal"
            v-model="dialog"
            persistent
            max-width="450">
            <v-card>
                <div class="modal-close-btn">
                    <div class="cross-style" @click="closeModal()">
                        x
                    </div>
                </div>
                <div class="modal-content">
                    <v-card-title class="center pt-0">
                        {{ $vuetify.lang.t('$vuetify.changePasswordModal.changePassword') }}
                    </v-card-title>
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col
                                    cols="12">
                                        <v-text-field
                                            :label="$vuetify.lang.t('$vuetify.changePasswordModal.newPassword')"
                                            v-model="form.password"
                                            placeholder=" "
                                            autocomplete="off"
                                            :rules="inputRules"
                                            type="password"
                                            :error-messages="errors.password">
                                        </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </div>
                <div class="modal-save-btn">
                    <v-btn
                        width="200"
                        color="primary"
                        @click="submitForm()">
                        {{ $vuetify.lang.t('$vuetify.changePasswordModal.save') }}
                    </v-btn>
                </div>
                <v-card-actions>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    name: 'ChangePasswordModal',

    props: {
        toUpdateUserId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            dialog: false,
            valid: true,
            form: {
                password: ''
            },
            errors: [],
            inputRules: [
                v => this.$validator.hasValue(v, this.trans.changePasswordModal.thisFieldIsRequired),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.changePasswordModal.thisFieldIsExceededCharacters)
            ]
        }
    },

    methods: {
        openModal () {
            this.dialog = true
        },

        clearForm () {
            this.form = {
                password: ''
            }
        },

        async submitForm () {
            if (!this.$refs.form.validate()) {
                return
            }

            await this.updatePassword()
        },

        async updatePassword () {
            this.$store.dispatch('setLoading', true)

            const res = await this.axios.put(`user/edit/${this.toUpdateUserId}`, this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: this.trans.changePasswordModal.congratulation,
                    text: this.trans.changePasswordModal.passwordOfUserIsUpdated,
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: this.trans.changePasswordModal.errorMessage,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        closeModal () {
            this.$refs.form.resetValidation()
            this.clearForm()
            this.dialog = false
        }
    },

    mounted () {
        this.registerLang({
            changePasswordModal: [
                'thisFieldIsRequired',
                'thisFieldIsExceededCharacters',
                'congratulation',
                'passwordOfUserIsUpdated',
                'errorMessage'
            ]
        })
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                if (this.dialog) {
                    this.$refs.form.resetValidation()
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
